import { ESLCourseData } from "../../data/ESL/ESLCourseData";
import ESLCourseTemplate from "../../pageTemplate/ESLCourseTemplate";
export default function ESLDOpage() {
    return (
        <div>
            <ESLCourseTemplate data={ESLCourseData[1]} />
        </div>
    )
}